import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-if-database",
  "use": "icon-if-database-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-if-database\"><path d=\"M16 13.856c6.368 0 11.552-1.888 11.552-4.192v-3.456c0-2.336-5.184-4.224-11.552-4.224s-11.52 1.888-11.52 4.224v3.456c0 2.304 5.152 4.192 11.52 4.192zM27.52 11.968c-0.416 2.176-5.44 3.904-11.52 3.904s-11.104-1.728-11.52-3.904c-0.032 0.096 0 5.696 0 5.696 0 2.336 5.152 4.224 11.52 4.224s11.552-1.888 11.552-4.224c0 0 0-5.568-0.032-5.696zM16 24c-6.080 0-11.104-1.728-11.52-3.904v5.696c0 2.336 5.152 4.224 11.52 4.224s11.552-1.888 11.552-4.224l-0.032-5.696c-0.416 2.176-5.44 3.904-11.52 3.904z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/if-database.svg
// module id = EI0f
// module chunks = 24